// extracted by mini-css-extract-plugin
export default {"title":"StepHeader_title__HBz11"};